import { Table } from '@shared/components'
import React, { useMemo } from 'react'

import { NoResults } from '@/components'
import { useMobile } from '@/hooks'
import { MemberDetail } from '@/types/User'

import { MobileStayCommitment } from './MobileStayCommitment'
import { StayCommitmentListColumns } from './StayCommitments.data'

export const StayCommitments = ({ member }: { member: MemberDetail }) => {
  const { isTablet } = useMobile()

  const stayCommitments = member.stayCommitments || []

  const columns = useMemo(() => {
    return StayCommitmentListColumns
  }, [])

  return (
    <div className="flex w-full flex-col py-4">
      <div className="mb-2 flex w-full items-center justify-between md:mb-4 md:flex-row">
        <h2 className=" text-header-lg leading-120">Stay Commitments</h2>
      </div>
      {isTablet ? (
        <>
          {(stayCommitments.length > 0 &&
            stayCommitments.map((stayCommitment, index) => (
              <MobileStayCommitment key={index} stayCommitment={stayCommitment} />
            ))) || <NoResults />}
        </>
      ) : (
        <Table columns={columns as any} data={stayCommitments} />
      )}
    </div>
  )
}
